import { apiClient } from "./apiClient";

import type { UserNotification } from "@/types/userNotification";

export const notificationsApi = {
  async listUnread(): Promise<UserNotification[]> {
    const response = await apiClient.get<UserNotification[]>("/v1/notifications/");
    return response.data;
  },

  async markRead(notificationId: number): Promise<UserNotification> {
    const response = await apiClient.post<UserNotification>(`/v1/notifications/${notificationId}/read`);
    return response.data;
  },
};
